module.exports = __webpack_public_path__ + "img/menu.8f55faaa.svg";